import React, { useState } from 'react';
import theme from './ResidentialExpandedListItem.module.scss';
import { CardSection, CardTags, CardRow } from '@/components/Cards';
import { ProjectRelativeLink } from '@/components/navigation';
import { Trans } from '@lingui/react/macro';
import { SelectableCard } from '@ygtechnologies/bygr-frontend-component-library';
import ResidentialUnitContextMenu from '@/seller/components/residential-units/ResidentialUnitContextMenu';
import { classnames } from '@/utils/html';
import { ResidentialUnitListItemProps } from '..';
import ResidentialUnitDeadlineList from '../../ResidentialUnitDeadlineList/ResidentialUnitDeadlineList';
import ExtraBuyerInfo from './ExtraBuyerInfo';
import { useLingui } from '@lingui/react';

const ResidentialExpandedListItem: React.FC<ResidentialUnitListItemProps> = ({
    hrefGenerator,
    residentialUnit,
    onDelete,
    onUpdate,
    notificationCountGetter = () => 0,
    selectedUnitIds = [],
    onUnitSelect,
}) => {
    const { _ } = useLingui();
    const isSelected = selectedUnitIds.includes(residentialUnit.id);

    const handleSelectionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onUnitSelect) {
            onUnitSelect(residentialUnit.id, e.target.checked);
        }
    };

    return (
        <SelectableCard
            isSelected={isSelected}
            handleSelectionChange={handleSelectionChange}
            notificationBadgeNumber={notificationCountGetter(residentialUnit.id)}>
            <div className={theme.listContainer}>
                <div className={theme.listContainerRow}>
                    <CardSection
                        width="30%"
                        caption={
                            <ProjectRelativeLink
                                className={classnames(theme.header, 'link-unstyled flex full-width')}
                                to={hrefGenerator(residentialUnit)}>
                                {residentialUnit.name}
                            </ProjectRelativeLink>
                        }>
                        <div>
                            <ProjectRelativeLink
                                className="link-unstyled flex full-width"
                                to={hrefGenerator(residentialUnit)}></ProjectRelativeLink>
                            <div>
                                <ExtraBuyerInfo buyers={residentialUnit.buyerInfo.users} />
                            </div>
                        </div>
                    </CardSection>
                    <CardSection width="10%" caption={<Trans>Unit type</Trans>}>
                        {_({ id: `ResidentialUnitType.${residentialUnit.type}` })}
                    </CardSection>
                    <CardSection width="10%" caption={<Trans>Layout type</Trans>}>
                        {residentialUnit.layoutType || '-'}
                    </CardSection>
                    <CardSection width="8%" caption={<Trans>Floor</Trans>}>
                        {residentialUnit.floor || '-'}
                    </CardSection>
                    <CardSection width="10%" caption={<Trans>Readonly</Trans>}>
                        {residentialUnit.isReadOnlyForBuyers ? <Trans>Yes</Trans> : <Trans>No</Trans>}
                    </CardSection>
                    <CardSection width="20%" caption={<Trans>Deadlines</Trans>}>
                        <ResidentialUnitDeadlineList deadlines={residentialUnit.deadlines} />
                    </CardSection>
                    <ResidentialUnitContextMenu
                        inCard
                        residentialUnit={residentialUnit}
                        onDelete={onDelete}
                        onUpdate={onUpdate}
                    />
                </div>
                <CardTags tags={residentialUnit.projectTags} />
            </div>
        </SelectableCard>
    );
};

export default React.memo(ResidentialExpandedListItem);
